export const StringHelper = (() => {
    function formatPhoneNumber(phoneNumber) {
        var cleaned = ("" + phoneNumber).replace(/\D/g, "");
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

        if (match) return "(" + match[1] + ") " + match[2] + "-" + match[3];
        else return null;
    }

    function formatRNC(rnc) {
        var cleaned = ("" + rnc).replace(/\D/g, "");
        var match = cleaned.match(/^(\d{3})(\d{5})(\d{1})$/);

        if (match) return match[1] + "-" + match[2] + "-" + match[3];
        else return cleaned;
    }

    function formatCedula(ced) {
        var cleaned = ("" + ced).replace(/\D/g, "");
        var match = cleaned.match(/^(\d{3})(\d{7})(\d{1})$/);

        console.dev(match);
        if (match) return match[1] + "-" + match[2] + "-" + match[3];
        else return cleaned;
    }

    function formatCurrency(amount = 0) {
        var formatter = new Intl.NumberFormat("DOP", {
            style: "currency",
            currency: "DOP",
        });

        return formatter.format(amount);
    }

    function formatNumber(n = 0) {
        return (Math.round(n * 100) / 100).toFixed(2);
    }

    const formatAmount = (num, decimals = 2) => {
        if (typeof num === "number" && num >= 0) {
            return num.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
            return 0;
        }
    };

    const firstLetterUppercase = (value) => {
        if (value?.length > 0) {
            return `${value.slice(0, 1).toUpperCase()}${value
                .slice(1)
                .toLowerCase()}`;
        } else {
            return "";
        }
    };

    const cutLetter = (letter, maxSize, endStr) => {
        if (letter?.length > 0) {
            return letter.length > maxSize
                ? letter.slice(0, maxSize) + endStr
                : letter;
        } else {
            return "";
        }
    };

    return {
        formatPhoneNumber,
        formatRNC,
        formatCurrency,
        formatNumber,
        formatCED: formatCedula,
        formatAmount,
        firstLetterUppercase,
        cutLetter,
    };
})();
